export default {
    list: {
        title: 'Shippers',
        subtitle: 'Manage your collaborations with shippers',
        loading: 'Loading shippers...',
        searchPlaceholder: 'Search by name or email...',
        countryPlaceholder: 'Filter by country',
        allCountries: 'All countries',
        tabs: {
            active: 'Active Shippers',
            pending: 'Pending Invites',
        },
        active: {
            title: 'Active Shippers',
            description: 'List of shippers you actively collaborate with',
            headers: {
                company: 'Company',
                country: 'Country',
                email: 'Email',
                status: 'Status',
                activeContainers: 'Active Containers',
                totalContainers: 'Total Containers',
                lastContainer: 'Last Container',
                collaborationDate: 'Collaboration Date',
                actions: 'Actions',
            },
        },
        receivedInvites: {
            title: 'Received Invites',
            description: 'Invites received from shippers awaiting acceptance',
            headers: {
                company: 'Company',
                country: 'Country',
                email: 'Email',
                inviteDate: 'Invite Date',
                actions: 'Actions',
            },
            accept: 'Accept',
            reject: 'Reject',
            confirmAccept: 'Are you sure you want to accept this invite?',
            confirmReject: 'Are you sure you want to reject this invite?',
        },
        sentInvites: {
            title: 'Sent Invites',
            description: 'Invites sent to shippers awaiting their acceptance',
            headers: {
                company: 'Company',
                country: 'Country',
                email: 'Email',
                inviteDate: 'Invite Date',
                actions: 'Actions',
            },
        },
        status: {
            active: 'Active',
            pending: 'Pending',
            rejected: 'Rejected',
            suspended: 'Suspended',
        },
        confirmSuspend: 'Are you sure you want to suspend this collaboration?',
        confirmDelete: 'Are you sure you want to delete this collaboration?',
        none: 'None',
    },
    detail: {
        loading: 'Loading shipper details...',
        notFound: {
            title: 'Shipper not found',
            message: 'The requested shipper does not exist or you do not have permission to view it.',
        },
        backToList: 'Back to list',
        info: {
            title: 'Information',
            collaboration: 'Collaboration',
            companyInfo: 'Company Information',
            containerStats: 'Container Statistics',
            fields: {
                legalName: 'Legal Name',
                entityType: 'Entity Type',
                taxId: 'Tax ID',
                country: 'Country',
                address: 'Address',
                email: 'Email',
                phone: 'Phone',
            },
            stats: {
                total: 'Total',
                inTransit: 'In Transit',
                delivered: 'Delivered',
                delayed: 'Delayed',
                pendingDocuments: 'Doc Pending',
                highRisk: 'High Risk',
            },
        },
        containers: {
            title: 'Containers from this Shipper',
            count: 'of',
            searchPlaceholder: 'Search by container ID or route...',
            statusPlaceholder: 'Filter by status',
            riskPlaceholder: 'Filter by risk',
            documentsPlaceholder: 'Filter by documents',
            headers: {
                containerId: 'Container ID',
                route: 'Route',
                progress: 'Progress',
                status: 'Status',
                docStatus: 'Doc Status',
                riskLevel: 'Risk Level',
                value: 'Value',
                actions: 'Actions',
            },
            noContainers: {
                title: 'No containers found',
                message: 'Try modifying the search filters',
                emptyMessage: 'No containers received from this shipper yet',
            },
            viewDetails: 'View Details',
        },
    },
};
